import css from "standard/css";

const style = css`
  :root {
    --font-family-highlight: 'Roboto Condensed', sans-serif;
    --font-family-base: 'Roboto', sans-serif;
  }
`;

export default style;
